<template>
    <glm-layout margin-footer>
        <world-map :specials="$page.props.mapCountries" height="200px">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center h-full justify-start">
                <div class="rounded-md max-w-lg inline-block p-2 bg-grey-700 text-white mt-3">
                    <h3 class="font-bold font-serif text-3xl">
                        About the Project
                    </h3>
                </div>
            </div>
        </world-map>

        <page-content class="mt-12">
            <h2 class="font-normal mb-3 text-glm-blue text-3xl font-serif">
                Headline
            </h2>

            <div class="grid gap-4 grid-cols-1 lg:grid-cols-2">
                <p>
                    A new G2LM|LIC dataset is in preparation. The Jobs of the World Project harmonises all available
                    micro
                    datasets that contain information on labour market activities and poverty to create a
                    multi-country
                    macro data-set that contains: LFP, occupational choices (sector, casual vs regular, wage vs
                    self-employment), earnings, hours worked, seasonality all by gender, education, age groups and
                    wealth.
                    This dataset will serve two purposes: (i) It will allow researchers to compare their particular
                    setting
                    to averages in the same country or region to get a sense of how widespread patterns are and
                    therefore
                    the extent to which their research can be informative for other settings, and (ii) It will allow
                    to
                    identify unexplained patterns and gaps in research.

                    The video below provides a short summary of the database. The database is part of the data
                    building
                    activities in the G2LM|LIC program which aims at studying gender, growth, and labour markets in
                    low-income countries.
                </p>

                <iframe
                    class="w-full h-full"
                    style="min-height: 250px"
                    src="https://www.youtube.com/embed/dkwEUQToyxM"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
            </div>
        </page-content>
    </glm-layout>
</template>

<script>
import GlmLayout from '@/Layouts/GlmLayout'
import WorldMap from '@/Components/WorldMap'
import PageContent from '@/Components/PageContent'

export default {
    components: {
        PageContent,
        WorldMap,
        GlmLayout,
    },

    data () {
        return {
            specials: [
                'AFG',
                'AGO',
                'ALB',
                'ARM',
                'AZE',
                'BDI',
                'BEN',
                'BFA',
                'BGD',
                'BOL',
                'BRA',
                'CAF',
                'CIV',
                'CMR',
                'COD',
                'COG',
                'COL',
                'COM',
                'DOM',
                'ECU',
                'ETH',
                'GAB',
                'GHA',
                'GIN',
                'GMB',
                'GTM',
                'GUY',
                'HND',
                'HTI',
                'IDN',
                'IND',
                'JOR',
                'KAZ',
                'KEN',
                'KGZ',
                'KHM',
                'LBR',
                'LKA',
                'LSO',
                'MAR',
                'MDA',
                'MDV',
                'MEX',
                'MGD',
                'MLI',
                'MMR',
                'MOZ',
                'MWI',
                'NAM',
                'NER',
                'NGA',
                'NIC',
                'NPL',
                'PAK',
                'PER',
                'PHL',
                'PNG',
                'PRY',
                'RWA',
                'SDN',
                'SEN',
                'SLE',
                'SLV',
                'STP',
                'TCD',
                'TGO',
                'THA',
                'TJK',
                'TLS',
                'TTO',
                'TUN',
                'TUR',
                'UGA',
                'UKR',
                'UZB',
                'VNM',
                'YEM',
                'ZAF',
                'ZMB',
                'ZWE',
            ],
        }
    },
}
</script>
